// extracted by mini-css-extract-plugin
export var bgOverlay = "styles-module--bgOverlay--37fa1";
export var button = "styles-module--button--c56d7";
export var popUpContainer = "styles-module--popUpContainer--be5af";
export var text = "styles-module--text--e9166";
export var whiteCross = "styles-module--whiteCross--3424d";